export const updateProfileImageInStorage = (imageUrl) => {
  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    user.profileImage = imageUrl;
    localStorage.setItem("user", JSON.stringify(user));
    // Fire event so AdminProfileDropDown re-reads from localStorage
    window.dispatchEvent(new Event("profileImageUpdated"));
  } catch (err) {
    console.error("Failed to update profile image:", err);
  }
};
